import { type FC } from 'react';

// MUI
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import Box from '@mui/material/Box';

// screen
import PdfPrintTitle from 'modules/map/components/pdf-print-form/PdfPrintTitle';
import type { TeacherMenuModel } from 'modules/map/components/teacher-menu/types';
import {
  sharedPrintTableStyles,
  SMALL_FONT_SIZE,
} from 'modules/map/components/pdf-print-form/utils';
import PrintThemeWrapper from 'modules/map/components/pdf-print-form/PrintThemeWrapper';
import SixDaysTeacherMenu from 'modules/map/components/teacher-menu/pdf/six-days/SixDaysTeacherMenu';
import { renderCell } from 'modules/map/components/pdf-print-form/utils';
import PdfTableHeader from 'modules/map/components/pdf-print-form/PdfTableHeader';
import FivedaysTeacherMenu from 'modules/map/components/teacher-menu/pdf/five-days/FivedaysTeacherMenu';
import FiveDaysFormFooter from 'modules/map/components/teacher-menu/pdf/five-days/FiveDaysFormFooter';
import SixDaysFormFooter from 'modules/map/components/teacher-menu/pdf/six-days/SixDaysFormFooter';

const menuWithCalorieInfo = [
  renderCell({ label: 'map.weekDayAndDate', rowSpan: 1, width: '10%' }),
  renderCell({ label: 'map.menuUppercase', rowSpan: 1, width: '45%' }),
  renderCell({ label: 'map.noteUppercase', rowSpan: 1, width: '45%' }),
];
interface PdfTeacherMenuProps {
  data: TeacherMenuModel;
}

/**
 * Giáo viên thì không có thông tin calories
 */
const PdfTeacherMenu: FC<PdfTeacherMenuProps> = ({ data }) => {
  const days = data?.structuredData?.data.items || [];
  const info = data?.structuredData?.data?.info;

  const tableHeight = days.length === 6 ? '74vh' : '79vh';

  return (
    <PrintThemeWrapper>
      <TableContainer className="px-2 tablet:px-4" sx={sharedPrintTableStyles}>
        <PdfPrintTitle title={info.title || ''} subTitle={''} week={info.weekTitle} />
        <Table sx={{ borderCollapse: 'separate', height: tableHeight }}>
          <PdfTableHeader
            firstRow={menuWithCalorieInfo}
            firstRowCustomStyle={{ fontSize: SMALL_FONT_SIZE }}
          />
          {days.length === 5 && <FivedaysTeacherMenu data={data} />}
          {days.length === 6 && <SixDaysTeacherMenu data={data} />}
        </Table>
        <Box sx={{ height: '14vh' }}>
          {days.length === 5 && <FiveDaysFormFooter footerInfo={info} />}
          {days.length === 6 && <SixDaysFormFooter footerInfo={info} />}
        </Box>
      </TableContainer>
    </PrintThemeWrapper>
  );
};

export default PdfTeacherMenu;
